/* eslint-disable */
import React, { useState } from "react";
import { Link } from 'react-router-dom';
/* Components */
import ShaiaBot from '../components/shaiaBot/shaiabot';

import Button from "../components/button/button";

import ArrowBack from '../assets/icons/arrow_back.svg';
import { useTranslation } from 'react-i18next';
import FormABP from '../components/form/formABP';
import useCaseABPStore from '../store/useCaseABPStore';
import ChatABP from '../components/chat-abp/chatABP';

const InteractionABP = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className='back-button'>
        <Link to={'/design-abp'} className='back-button_arrow'><img src={ArrowBack} className='' alt='' /><span className=" whitespace-nowrap overflow-hidden text-ellipsis">Regresar a formulario</span></Link>
        <span className='back_button_root'>Shaia /</span>
        <span className='back_button_page'>{t('abpText1')}</span>
      </div>
      <div className="wrapper d-dialog">
        <ChatABP />
      </div>
    </>
  );
}

export default InteractionABP;